/** @format */

// src/components/PermissionSection1.jsx
import React from "react";
import { IoPersonOutline } from "react-icons/io5";
import { PiBabyCarriageDuotone } from "react-icons/pi";
import { PiHeartbeatLight } from "react-icons/pi";
function RolePermissionOne({ rolePermissionIds, onTogglePermission }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Member Registration */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <IoPersonOutline />

          <span>Dashboard</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="dashboard"
              checked={rolePermissionIds.includes("1")}
              onChange={() => onTogglePermission("1")}
            />
            <span className="ml-2 text-gray-700">Dashboard Overview</span>
          </label>
        </div>
      </div>

      {/* Employee Management */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <PiBabyCarriageDuotone />
          <span>Employee Management</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="employeemanagementoverview"
              checked={rolePermissionIds.includes("2")}
              onChange={() => onTogglePermission("2")}
            />
            <span className="ml-2 text-gray-700">
              Employee Management Overview
            </span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="employeeonboarding"
              checked={rolePermissionIds.includes("1000")}
              onChange={() => onTogglePermission("1000")}
            />
            <span className="ml-2 text-gray-700">Employee Onboarding</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="viewemployeedetails"
              checked={rolePermissionIds.includes("1001")}
              onChange={() => onTogglePermission("1001")}
            />
            <span className="ml-2 text-gray-700">View Employee Details</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="editemployeedetails"
                checked={rolePermissionIds.includes("1002")}
                onChange={() => onTogglePermission("1002")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
        </div>
      </div>

      {/* Time & Attendance */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <PiHeartbeatLight />

          <span>Time & Attendance</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="timeAndAttendanceOverview"
              checked={rolePermissionIds.includes("3")}
              onChange={() => onTogglePermission("3")}
            />
            <span className="ml-2 text-gray-700">
              Time & Attendance Overview
            </span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="liveDashboard"
              checked={rolePermissionIds.includes("100")}
              onChange={() => onTogglePermission("100")}
            />
            <span className="ml-2 text-gray-700">Live Dashboard</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="timeManagement"
              checked={rolePermissionIds.includes("101")}
              onChange={() => onTogglePermission("101")}
            />
            <span className="ml-2 text-gray-700">Time Management</span>
          </label>

          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="createTimetable"
                checked={rolePermissionIds.includes("10001")}
                onChange={() => onTogglePermission("10001")}
              />
              <span className="ml-2 text-gray-700">Create Timetable</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="action"
                checked={rolePermissionIds.includes("10002")}
                onChange={() => onTogglePermission("10002")}
              />
              <span className="ml-2 text-gray-700">Action</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="absenceReport"
              checked={rolePermissionIds.includes("102")}
              onChange={() => onTogglePermission("102")}
            />
            <span className="ml-2 text-gray-700">Absence Report</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="attendanceAdjustment"
              checked={rolePermissionIds.includes("103")}
              onChange={() => onTogglePermission("103")}
            />
            <span className="ml-2 text-gray-700">Attendance Adjustment</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="checkinCheckoutReport"
              checked={rolePermissionIds.includes("104")}
              onChange={() => onTogglePermission("104")}
            />
            <span className="ml-2 text-gray-700">Checkin-checkout Report</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default RolePermissionOne;
